import React from "react";
import "../../css/searchButon.css";
const SearchButton = () => {
  return <button className="btn btn-primary">Search</button>;
};

export default SearchButton;
